import React, { useEffect, useRef } from 'react';
import L from 'leaflet';

export default function Intro(props) {
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRef = useRef(null);

    // Initialize map only once on mount
    useEffect(() => {
        if (!mapRef.current) {
            console.warn('mapRef.current is null, delaying map initialization');
            return;
        }

        // Initialize map instance only once
        if (!mapInstanceRef.current) {
            const initialCenter = [0, 0];
            const initialZoom = 2;
            const mapInstance = L.map(mapRef.current).setView(initialCenter, initialZoom);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors'
            }).addTo(mapInstance);
            mapInstanceRef.current = mapInstance;
        }

        // Cleanup on unmount
        return () => {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
        };
    }, []);

    // Update map view and marker when usercoords changes
    useEffect(() => {
        const map = mapInstanceRef.current;
        if (!map || !props.usercoords) return;

        // Parse usercoords if it's a string "lat,lng"
        let coords = props.usercoords;
        if (typeof coords === 'string') {
            const parts = coords.split(',');
            if (parts.length === 2) {
                const lat = parseFloat(parts[0]);
                const lng = parseFloat(parts[1]);
                if (!isNaN(lat) && !isNaN(lng)) {
                    coords = [lat, lng];
                } else {
                    return; // invalid coords
                }
            } else {
                return; // invalid coords
            }
        }

        // Set view to new coords with zoom 20
        map.setView(coords, 20);

        // Remove existing marker if any
        if (markerRef.current) {
            markerRef.current.remove();
            markerRef.current = null;
        }

        // Add new marker
        const userMarker = L.marker(coords).addTo(map);
        userMarker.bindPopup(`You are here!`);
        userMarker.openPopup();

        markerRef.current = userMarker;
    }, [props.usercoords]);

    return (
        <div style={{ position: "relative", height: props.height || "100%", borderRadius: "10px 10px 0 0", overflow: "hidden" }}>
            <style>
                {`
          .leaflet-routing-alternatives-container {
            display: none;
          }
        `}
            </style>
            <div ref={mapRef} style={{ width: "100%", height: "100%" }}></div>
        </div>
    );
}
